import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { Component, Inject } from '@angular/core';
import { StationGroup } from 'src/tmc-yard/client/model/station-group';
import { TranslationService, MasterDetailListEntry } from '@sdbn/common';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DictionaryKeySelectOption } from '@sdbn/appclient';
import { StructureSelectionContext } from 'src/tmc-yard/common/structure-selection/structure-selection.model';
import { ForwardToStationSelectionResult } from '../model/forward-to-station.model';
import { ConfigurationService } from '@sdbn/appclient';
import { StationType } from 'src/tmc-yard/client/model/station-type.enum';

@Component({
    selector: 'app-forward-to-station-dialog',
    templateUrl: './forward-to-station.component.html',
    styleUrls: ['./forward-to-station.component.scss']
})
export class ForwardToStationStructureSelectionDialogComponent {

    stationGroups: Array<StationGroup>;

    selectedStationGroup: StationGroup = null;

    selectionValid = false;

    selectedOption: DictionaryKeySelectOption;

    constructor(
        public configurationService: ConfigurationService,
        public translationService: TranslationService,
        private tmcContextService: TmcContextService,
        private dialog: MatDialogRef<ForwardToStationStructureSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: StructureSelectionContext,
    ) {

        data.validation$.subscribe(validation => {
          if (this.data.selection.stationId != null) {
            const station = tmcContextService.findStationById(this.data.selection.stationId);
            if ( (station?.stationType === StationType.WORKING_AREA && station?.stationUsage?.transports?.length > 0)
                || station?.stationUsage?.suspended
                || station?.stationUsage?.disabled) {
              console.log('station is occupied/suspended/disabled. Selection is invalid');
              this.selectionValid = false;
            } else {
              this.selectionValid = validation;
            }
          } else {
            this.selectionValid = validation;
          }
        });
    }

    public optionsChanged(event: DictionaryKeySelectOption) {
      this.selectedOption = event;
    }

    onSelectionChanged(entry: MasterDetailListEntry) {
        const stationGroup = entry as StationGroup;
        this.data.setStationGroupSelection(stationGroup.id);
    }

    confirmDialog() {
        this.data.validation$.unsubscribe();
        const result = new ForwardToStationSelectionResult();
        result.reasonOptionDictionaryKey = this.selectedOption == null ? null : this.selectedOption.dictionaryKey;
        result.stationGroupId = this.data.selection.stationGroupId;
        result.stationSetId = this.data.selection.stationSetId;
        result.stationId = this.data.selection.stationId;
        this.dialog.close(this.data.selection);
    }

    cancelDialog() {
        this.data.validation$.unsubscribe();
        this.dialog.close(null);
    }

}
